import type { DataBuilderSettingsGroup } from '../../DataBuilder/api/data-builder-api.types';
import type { SettingsValues } from './helpers/settings-value';
import { asString, asStringArray } from './helpers/settings-value';

const hasPattern = (pattern: string | null | undefined): pattern is string =>
  pattern !== undefined && pattern !== null && pattern !== '';

const matchesPattern = (pattern: string, value: string): boolean => {
  try {
    const regex = new RegExp(`^(?:${pattern})$`);
    return regex.test(value);
  } catch {
    console.warn(
      `[data-builder-settings] invalid regex pattern "${pattern}" from backend`
    );
    return true;
  }
};

export const getSettingsValidationErrors = (
  groups: DataBuilderSettingsGroup[],
  values: SettingsValues
): Record<string, string> => {
  const errors: Record<string, string> = {};

  for (const group of groups) {
    for (const section of group.sections) {
      if (section.type === 'text') {
        const value = asString(values[section.key]);
        if (section.required && value === '') {
          errors[section.key] = `${section.label} is required.`;
          continue;
        }
        if (
          hasPattern(section.pattern) &&
          value !== '' &&
          !matchesPattern(section.pattern, value)
        ) {
          errors[section.key] =
            `${section.label} is not in the expected format ${section.pattern}.`;
        }
        continue;
      }

      if (section.type === 'select' && section.required) {
        const isEmpty = section.multi
          ? asStringArray(values[section.key]).length === 0
          : asString(values[section.key]) === '';
        if (isEmpty) {
          errors[section.key] = `${section.label} is required.`;
        }
      }
    }
  }

  return errors;
};
